import { cn } from '~/lib/utils';

/**
 * SkeletonText
 *
 * A component for building skeletion text and painlessly mirroring position size
 * and line height of actual text. Depends on Tailwind CSS (https://tailwindcss.com)
 *
 * Default Example:
 *  <SkeletonText className='w-5/6 text-lg leading-tight text-neutral-5' />
 *
 * Responsive Example:
 *  <SkeletonText className='w-5/6 text-xs md:text-lg md:leading-tight text-neutral-5' />
 */

interface SkeletonTextProps {
  className: string;
}

export function SkeletonText(props: SkeletonTextProps) {
  const { className } = props;

  return (
    <div
      className={cn('flex items-center', 'before:h-[.75em] before:grow before:rounded-sm before:bg-current', className)}
      /**
       * We use &nbsp; as a handy way to hack mirroring line height. Should lh units
       * become acceptable for use, we'd remove &nbsp; in favor of a `h-lh` className.
       *
       * https://www.w3.org/TR/css-values-4/#lh
       */
    >
      &nbsp;
    </div>
  );
}
